export default __webpack_public_path__ + "static/media/the-wave-concept-2400x1350.22b7c6f4.jpg";